import { render, staticRenderFns } from "./breed_page_sel.vue?vue&type=template&id=899bc440&scoped=true"
import script from "./breed_page_sel.vue?vue&type=script&lang=js"
export * from "./breed_page_sel.vue?vue&type=script&lang=js"
import style0 from "./breed_page_sel.vue?vue&type=style&index=0&id=899bc440&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899bc440",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('899bc440')) {
      api.createRecord('899bc440', component.options)
    } else {
      api.reload('899bc440', component.options)
    }
    module.hot.accept("./breed_page_sel.vue?vue&type=template&id=899bc440&scoped=true", function () {
      api.rerender('899bc440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/breed_page_sel.vue"
export default component.exports